import axios from 'src/utils/axios';
import { endpoints } from 'src/utils/api-endpoints';
import { JobRole } from 'src/models/job-role';
import { AppResponse } from 'src/models/app-response';


export async function getJobRoles(orgId: string): Promise<AppResponse<JobRole[]>> {
  const URL = endpoints.jobRole.getAll;
  try {
    const response = await axios.get(URL);
    return response.data;
  } catch (error) {
    console.error('Failed to get jobRoles:', error);
    return {success: false, data: [], error}
  }
}

export async function getJobRoleById(jobRoleId: string): Promise<AppResponse<JobRole | null>> {
  try {
    const response = await axios.get(endpoints.jobRole.getById(jobRoleId));
    return response.data;
  } catch (error) {
    console.error('Failed to get job role:', error);
    return { success: false, data: null, error };
  }
}

export async function createJobRole(jobRole: Omit<JobRole, '_id'| 'organization'>): Promise<AppResponse<JobRole | null>> {
  const url = `${endpoints.jobRole.create}`;
  try {
    const response = await axios.post(url, jobRole);
    return response.data;
  } catch (error) {
    console.error('Failed to add jobRole:', error);
    return {success: false, data: null, error}
  }
}

export async function editJobRole(jobRole: Partial<JobRole> & { _id: string }): Promise<AppResponse<JobRole | null>> {
  const url = endpoints.jobRole.edit(jobRole._id);
  try {
    delete (jobRole as Partial<JobRole>)._id;
    const response = await axios.put(url, jobRole);
    return response.data;
  } catch (error) {
    console.error('Failed to edit jobRole:', error);
    return {success: false, data: null, error}
  }
}

export async function deleteJobRole(jobRoleId: string): Promise<AppResponse<void>> {
  const url = endpoints.jobRole.delete(jobRoleId);
  try {
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    console.error('Failed to delete jobRole:', error);
    return { success: false, data: undefined, error };
  }
}
export async function addSkillToJobRole(jobRoleId: string, skillId: string): Promise<AppResponse<JobRole | null>> {
  try {
    const response = await axios.post(endpoints.jobRole.addSkill(jobRoleId, skillId));
    return response.data;
  } catch (error) {
    console.error('Failed to add skill to job role:', error);
    return { success: false, data: null, error };
  }
}

export async function removeSkillFromJobRole(jobRoleId: string, skillId: string): Promise<AppResponse<JobRole | null>> {
  try {
    const response = await axios.delete(endpoints.jobRole.removeSkill(jobRoleId, skillId));
    return response.data;
  } catch (error) {
    console.error('Failed to remove skill from job role:', error);
    return { success: false, data: null, error };
  }
}

export async function getUsersByJobRole(jobRoleId: string): Promise<AppResponse<JobRole[]>> {
  try {
    const response = await axios.get(endpoints.jobRole.getUsers(jobRoleId));
    return response.data;
  } catch (error) {
    console.error('Failed to get users by job role:', error);
    return { success: false, data: [], error };
  }
}